export default __webpack_public_path__ + "assets/7800573d487cab610b3280464eeba7e4.jpg";